import script from "./PlanConfirm.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlanConfirm.vue?vue&type=script&setup=true&lang=ts"

import "./PlanConfirm.vue?vue&type=style&index=0&id=17c318f4&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17c318f4"]])

export default __exports__